





import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { sortByProp } from "../../settings/themeSettings";
import { COMPAGNIE_VOL_URL } from "../../settings/APISetting";
import axiosInstance from "../../config/axiosConfig";

export const fetchCompagnieVol = createAsyncThunk('fetch-programme', async (page = 1) => {
    const response = await axiosInstance.get(COMPAGNIE_VOL_URL);
    return response.data;
});


export const createCompagnieVol = (compagnie, err, cb) => {
    axiosInstance.post(COMPAGNIE_VOL_URL, compagnie)
        .then((response) => {
            cb(response.data);
        })
        .catch(err);
}


export const updateCompagnieVol = (compagnie, err, cb) => {
    axiosInstance.put(`${COMPAGNIE_VOL_URL}/${compagnie.id}`, compagnie)
        .then((response) => {
            cb(response.data);
        })
        .catch(err);
}


export const deleteCompagnieVol = (id, err, cb) => {
    axiosInstance.delete(`${COMPAGNIE_VOL_URL}/${id}`)
        .then((response) => {
            cb(response.data);
        })
        .catch(err);
}
const compagnieVolSlice = createSlice({

    name: 'compagnieVols',
    initialState: {compagnieVols: [], compagnieVolFetchStatus: '' , compagnieVolsName : []},

    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCompagnieVol.fulfilled, (state, action) => {

            state.compagnieVols =[...action.payload].sort((a,b) => sortByProp(a,b, 'nom'));
            state.compagnieVolsName = [...[...action.payload].sort((a,b) => sortByProp(a,b, 'nom'))].map((i) => i.nom);
            state.compagnieVolFetchStatus = 'success';
        }).addCase(fetchCompagnieVol.pending, (state, action) => {
            state.compagnieVolFetchStatus = 'loading';

        }).addCase(fetchCompagnieVol.rejected, (state, action) => {

            state.compagnieVolFetchStatus = 'error';

        });
    }


});
export default compagnieVolSlice;